import "bootstrap/dist/css/bootstrap.css";
import { AccessDenied, ButtonComponent, ContainerLoader, CustomModal, NotFound } from "common-components";
import "common-components/src/styles/auto-index.scss";
import { Suspense } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useNavigate
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "typeface-montserrat";
import Cookies from "universal-cookie";

import {
  resetLoggedUser,
  setLoggedUser,
  setPageLoading,
  setSessionExtend,
  setsessionToken,
  setTimeoutId,
} from "./app/commonSlice";
import { authRoutes, routes } from "./app/routes";
import { store } from "./app/store";
import "./assets/css/alert.scss";
import "./assets/css/calender-custom.scss";
import "./assets/css/chip.scss";
import "./assets/css/common.scss";
import "./assets/css/custom.scss";
import "./assets/css/dropdown.scss";
import "./assets/css/internal.scss";
import "./assets/css/modal.scss";
import "./assets/css/navbar.scss";
import "./assets/css/tooltip.scss";
import IdleTimercontainer from "./IdleTimercontainer";
import { refreshTokenApi } from "./Modules/Home/HomeApiSlice";
import { resetHomeData } from "./Modules/Home/HomeSlice";
import PrivateRoute from "./PrivateRoute";
import { rolePaths } from "./app/Constants"

function SessionTimeoutModalBody() {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const navigate = useNavigate();
  const TimeoutId = useSelector((state) => state.common.TimeoutId);

  const handleStayOnPage = () => {
    if (TimeoutId) {
      clearTimeout(TimeoutId);
      setTimeoutId(null); // Reset the timeout ID in the state
      dispatch(setSessionExtend(false));

      dispatch(refreshTokenApi()).then((data) => {
        if (data?.payload?.jwtToken) {
          cookies.set("apitoken", data?.payload?.jwtToken, { path: "/" });
          dispatch(setsessionToken(true));
        }
      });
    }
  };

  const logout = () => {
    if (TimeoutId) {
      clearTimeout(TimeoutId);
      setTimeoutId(null); // Reset the timeout ID in the state
      dispatch(setSessionExtend(false));
      sessionStorage.setItem("isLoggedin", false);
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      fetch("/auth?logout", {
        method: "GET",
        headers: {
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        redirect: "manual",
      })
        .then(() => {
          handleLogout();
          dispatch(resetLoggedUser());
          dispatch(resetHomeData());
          dispatch(setsessionToken(false));
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };
  const handleLogout = () => {
    cookies.remove("jwttoken", { path: "/" });
    cookies.remove("Refersh", { path: "/" });
    cookies.remove("apitoken", { path: "/" });
    cookies.remove("username", { path: "/" });
    cookies.remove("decodedUsername", { path: "/" });
    cookies.remove("referstoken", { path: "/" });
    dispatch(setLoggedUser({ userName: "", decodedUsername: "", userRole: "", token: "" }));
    dispatch(setPageLoading(true));
    navigate("/auth");
  };
  return (
    <>
      <h4 className="delete-h border-bottom">
        Your session is about to expire
      </h4>
      <p>Do you want to stay on the page? or Logout</p>
      <div className="btnswrap btn-dlt">
        <ButtonComponent
          className="btnStyle"
          onClick={() => {
            handleStayOnPage();
          }}
          text="Stay on Page"
        />
        <ButtonComponent
          className="btnStyle"
          onClick={() => {
            logout();
          }}
          text="Logout"
        />
      </div>
    </>
  );
}

function App() {
  const { loggedUser } = useSelector((state) => state.common);
  const { userRole } = loggedUser;
  const CisoPageAccessRole = ["Ciso", "Operation"];
  const isAccessDenied = (routepath) => {

    return userRole?.some((role) =>
      rolePaths[role]?.some((path) => routepath.includes(path)),
    );
  };
  const renderRoutes = (allRoutes) => {
    return allRoutes.flatMap((route) => {
      const elements = [];

      if (route?.path) {
        if (route?.layout && route?.component && route?.childNavs) {
          const childRoutes = route?.childNavs.map((child) => ({
            ...child,
            path: child?.path.replace(`${route?.path}/`, ""),
          }));
          elements.push(
            <Route key={route?.key} path={route?.path} element={getRouteElement(route)}>
              <Route index element={<Navigate to={childRoutes[0]?.path} replace />} />
              {renderRoutes(childRoutes)}
            </Route>
          );
          return elements;
        }

        if (route?.component) {
          elements.push(
            <Route key={route?.key} path={route?.path} element={getRouteElement(route)} />
          );
        } else if (route?.childNavs && !route?.navigationDisable) {
          const firstChild = route?.childNavs.find((e) => e?.path);
          if (firstChild) {
            elements.push(
              <Route
                key={route?.key}
                path={route?.path}
                element={<Navigate to={firstChild?.path.includes(route?.path) ? `/${firstChild?.path}` : `${route?.path}/${firstChild?.path}`} replace />}
              />
            );
          }
        }
      }

      if (route?.childNavs && !route?.layout) {
        elements.push(...renderRoutes(route?.childNavs));
      }

      return elements;
    });
  };

  const getRouteElement = (route) => {
    if (!userRole) {
      return <Navigate to="/auth" replace />;
    }

    if (userRole.includes("Ciso") && route.path.includes("configuration/administration")) {
      return <Navigate to="/access-denied" replace />;
    }

    const isCisoInsightsRestricted =
      userRole.length > 0 &&
      !userRole.some((role) => CisoPageAccessRole.includes(role)) &&
      route.path.includes("cisoInsights");

    if (isCisoInsightsRestricted || isAccessDenied(route.path)) {
      return <Navigate to="/access-denied" replace />;
    }

    return route.component;
  };
  const sessionExtend = useSelector((state) => state.common.sessionExtend);
  return (
    <Provider store={store}>
      <ToastContainer />
      <Suspense fallback={<ContainerLoader />}>
        {sessionExtend && (
          <CustomModal
            modalOpen={sessionExtend}
            closeBtn={false}
            modalBody={() => <SessionTimeoutModalBody />}
          />
        )}
        <IdleTimercontainer />

        <Routes>
          {authRoutes.map((route) => (
            <Route
              key={route.key}
              path={route.path}
              element={route.component}
            />
          ))}

          <Route path="/" element={<PrivateRoute />}>
            {renderRoutes(routes)}
            <Route path="/access-denied" element={<AccessDenied />}></Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Provider>
  );
}

export default App;
